import { onDateChangeType } from '../types'

export const defaultOnDateChange:onDateChangeType = (date) => date;
